<div class="pme-container">
    <pme-window-shop-manager-header *ngIf="this.headerContent" [headerContent]="this.headerContent">
    </pme-window-shop-manager-header>

    

   

    <!--PRODUCT LISTING-->
    <!--Desktop view -->
    <div class="display-utils-row display-utils-lt-md-col display-utils-start-center display-utils-only-gt-xs"
        style="margin-top: 16px;">
        <div class="display-utils-lt-md-flex-100 display-utils-gt-md-flex-15">
            <p>Escolha seu pacote de recarga:</p>
        </div>

        <div class="pme-carousel-swiper-container display-utils-lt-md-flex-100 display-utils-gt-md-flex-85">

            <ng-container *ngIf="packages">
                <pme-carousel-swiper [identifier]="'recarga-products'" [items]="packages">
                    <ng-template let-product let-i="index">
                        <pme-product-assinatura [productData]="product" (buyClicked)="navigate(i)"></pme-product-assinatura>
                    </ng-template>
                </pme-carousel-swiper>
            </ng-container>
        </div>
    </div>
    <!-- end Desktop view -->

    <!--Mobile view -->
    <div class="display-utils-col display-utils-start-stretch display-utils-hide-gt-xs" style="margin-top: 16px;">
        <div class="display-utils-flex-100">
            <p style="text-align: center;">Escolha seu pacote de recarga:</p>
        </div>
        <div class="display-utils-col display-utils-start-stretch display-utils-gap-8 display-utils-flex-100">
            <ng-container *ngIf="packages">
                <pme-product-assinatura [productData]="package" *ngFor="let package of packages; let i = index"
                    (buyClicked)="navigate(i)"></pme-product-assinatura>
            </ng-container>
        </div>
    </div>
    <!-- end Mobile view -->
    <!-- end Product Listing -->


    <mat-divider class="divider"></mat-divider>
    <pme-payment-methods></pme-payment-methods>
    <mat-divider class="divider"></mat-divider>
    <div class="pme-container">